import React from "react";
import { CompaniesApiResponse } from "../../../../utils/types";

interface CompaniesExportButtonProps {
  data: CompaniesApiResponse | undefined;
}

const CompaniesExportButton: React.FC<CompaniesExportButtonProps> = ({
  data,
}) => {
  const exportToCSV = () => {
    if (!data?.users.data) return;

    const headers = [
      "Company Name",
      "Category",
      "Keyword",
      "MT Responses",
      "MO Count",
      "Created At",
    ].join(",");
    const rows = data.users.data
      .map((row) =>
        [
          `"${row.name.replace(/"/g, '""')}"`,
          `"${row.category.replace(/"/g, '""')}"`,
          `"${row.keyword.replace(/"/g, '""')}"`,
          row.mt_responses_count,
          row.mo_count,
          new Date(row.created_at).toLocaleString(),
        ].join(",")
      )
      .join("\n");

    const csvContent = `data:text/csv;charset=utf-8,${headers}\n${rows}`;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "companies_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="p-4 flex justify-end">
      <button
        onClick={exportToCSV}
        className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors duration-200 font-medium text-sm sm:text-base shadow-md"
      >
        Export to CSV
      </button>
    </div>
  );
};

export default CompaniesExportButton;
